import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { Provider } from './Context';

import TagManager from 'react-gtm-module';

const tagManagerArgs = {
  gtmId: 'GTM-WP97FJR' // Replace with your GTM Container ID
};

TagManager.initialize(tagManagerArgs);

const root = ReactDOM.createRoot(document.getElementById('root'));

// Notify the user when a new version of the app is available
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    if (window.confirm('A new version of the app is available. Would you like to update now?')) {
      if (registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        registration.waiting.addEventListener('statechange', (event) => {
          if ((event.target).state === 'activated') {
            // Reload the page to apply the update
            window.location.reload();
          }
        });
      }
    }
  },
});

root.render(
  <React.StrictMode>
    <Provider>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();